import React from 'react';
import renderHTML from 'react-render-html';
import AppWrapper from '../../app-wrapper';
import { ERROR_CONTENT } from '../../app-constants';
import { getEventRouteAndUserHashDetails } from '../../app-actions';
import ViewHeader from '../../components/view-header';


const ErrorPagePresenter = (props) => {
  const eventRouteDetails = getEventRouteAndUserHashDetails();
  const { errorScenarios, errorSection } = props;
  const errorMessage = sessionStorage.getItem('errorMessage');
  const purlAppPresent = window.tcom.researchInsights.appConfig.purlApp;
  const errorDescription = errorScenarios && errorScenarios[errorMessage];
  const errorContent = {
    heading: ERROR_CONTENT.heading,
    description: errorMessage && errorMessage.length > 2 && errorDescription ? errorDescription : ERROR_CONTENT.description,
  };
  const errorContentSSM = {
    heading: errorSection ? errorSection.title : ERROR_CONTENT.heading,
    description: errorSection ? renderHTML(errorSection.description) : renderHTML(ERROR_CONTENT.description),
  };
  if (purlAppPresent) {
    return (
      <div className="root-container container">
        <ViewHeader
          content={eventRouteDetails.isEventRouteAndUserHashPresent
            || eventRouteDetails.isHostedRoutePresent
            || eventRouteDetails.isBusinessPopMailRoutePresent
            ? errorContent : errorContentSSM}
        />
      </div>
    );
  }
  return (
    <AppWrapper>
      <div className="root-container container">
        <ViewHeader
          content={eventRouteDetails.isEventRouteAndUserHashPresent
            || eventRouteDetails.isHostedRoutePresent
            || eventRouteDetails.isBusinessPopMailRoutePresent
            ? errorContent : errorContentSSM}
        />
      </div>
    </AppWrapper>
  );
};

export default ErrorPagePresenter;
